module.exports = __webpack_public_path__ + "img/bed.2ae33609.svg";